import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";

import { MonitorViewVehicleRoutes } from "./monitorViewVehicleRoutes";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { MonitorViewVehicleCurrentStatus } from "./monitorViewVehicleCurrentStatus";
import { MonitorViewVehicleShift } from "./monitorViewVehicleShift";
import { useAppDispatch } from "../../../framework/customStore";
import {
    setIsVehicleRouteView,
    setIsVehicleShiftTabView,
} from "../../../store/monitorViewSlice";
import { TransportOrderListItemDto } from "../../../models/transport/transportOrder";

const tabs = {
    now: "now",
    route: "route",
    vehicleShift: "vehicleShift",
};

interface MonitorViewVehicleProps {
    transportOrders?: TransportOrderListItemDto[];
}

export const MonitorViewVehicle = ({
    transportOrders,
}: MonitorViewVehicleProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [selectedTab, setSelectedTab] = useState<string>(tabs.now);

    const onChangeTab = (newValue: string) => {
        dispatch(setIsVehicleRouteView(newValue === tabs.route));
        dispatch(setIsVehicleShiftTabView(newValue === tabs.vehicleShift));
        setSelectedTab(newValue);
    };

    useEffect(() => {
        dispatch(setIsVehicleRouteView(selectedTab === tabs.route));
        dispatch(setIsVehicleShiftTabView(selectedTab === tabs.vehicleShift));
    }, []);

    return (
        <>
            <Box sx={{ bgcolor: "#f5f5f5" }}>
                <Tabs
                    value={selectedTab}
                    onChange={(event, newValue) =>
                        onChangeTab(newValue as string)
                    }
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab
                        key={tabs.now}
                        value={tabs.now}
                        label={
                            <Box sx={{ textAlign: "center" }}>
                                <Typography
                                    variant="caption"
                                    sx={{ fontSize: "0.7rem" }}
                                >
                                    {t("monitorView.now")}
                                </Typography>
                            </Box>
                        }
                        sx={{ minWidth: 0, padding: "6px" }}
                    />
                    <Tab
                        key={tabs.route}
                        value={tabs.route}
                        label={
                            <Box sx={{ textAlign: "center" }}>
                                <Typography
                                    variant="caption"
                                    sx={{ fontSize: "0.7rem" }}
                                >
                                    {t("monitorView.dailyRoute")}
                                </Typography>
                            </Box>
                        }
                        sx={{ minWidth: 0, padding: "6px" }}
                    />
                    <Tab
                        key={tabs.vehicleShift}
                        value={tabs.vehicleShift}
                        label={
                            <Box sx={{ textAlign: "center" }}>
                                <Typography
                                    variant="caption"
                                    sx={{ fontSize: "0.7rem" }}
                                >
                                    {t("monitorView.vehicleShift")}
                                </Typography>
                            </Box>
                        }
                        sx={{ minWidth: 0, padding: "6px" }}
                    />
                </Tabs>
            </Box>
            {selectedTab === tabs.now ? (
                <MonitorViewVehicleCurrentStatus
                    transportOrders={transportOrders}
                />
            ) : selectedTab === tabs.route ? (
                <MonitorViewVehicleRoutes
                    transportOrders={transportOrders}
                />
            ) : (
                <MonitorViewVehicleShift
                    transportOrders={transportOrders}
                />
            )}
        </>
    );
};
